export const CREATE_PROFILE = `
mutation(
  $firstName: String
  $lastName: String
  $userName: String
  $userId: ID
  $email: String
) {
  createProfile(
    input: {
      data: {
        firstName: $firstName
        lastName: $lastName
        userName: $userName
        userId: $userId
        email: $email
      }
    }
  ) {
    profile {
      id
      firstName
      lastName
      userName
    }
  }
}
`

export const UPDATE_BALANCE = `
mutation($profileId: ID!, $balance: Float) {
  updateUserBalance(profileId: $profileId, balance: $balance) {
    id
    balance
  }
}
`